
function timeAgo(ts: number) {
  const s = Math.floor((Date.now() - ts) / 1000);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  return `${h}h`;
}

type StatusValue = 'ok' | 'warn' | 'offline' | 'fresh' | 'stale' | 'malformed' | 'unknown' | undefined;

export function StatusDot({ status, updatedAt }: { status?: StatusValue, updatedAt?: number | null }) {
  let state = status === 'fresh' ? 'ok' : status === 'stale' || status === 'malformed' ? 'warn' : status;
  if (!state && updatedAt) {
    const age = Date.now() - updatedAt;
    state = age <= 60000 ? 'ok' : 'warn';
  }
  const title = updatedAt
    ? `Updated ${timeAgo(updatedAt)} ago (${new Date(updatedAt).toISOString()})`
    : 'No recent price update';
  return (
    <span className={`status-dot ${state}`} title={`Freshness indicator only. ${title}`} aria-label={`Freshness indicator: ${state || "unknown"}. ${title}`} />
  );
}
